<!-- <div class="kt-mat-alert" role="alert">
	<div class="kt-mat-alert__text">
		<h5 style="color: black;">{{data.message}}</h5>
	</div>
	<div *ngIf="showCloseButton">
		<button type="button"
			mat-icon-button
			color="warn"
			(click)="closeAlert()">
			<mat-icon class="material-icons">clear</mat-icon>
		</button>
	</div>
</div> -->

<div class="kt-portlet">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle class="kt-portlet__head kt-portlet__head__custom">
        <div class="kt-portlet__head-label">
            <h3 class="kt-portlet__head-title">Note:</h3>
        </div>
    </div>
    <div class="kt-form">
        <div class="kt-portlet__body">
			<div class="form-group kt-form__group row">
				<div class="col-lg-12">
					<mat-dialog-content class="mat-typography" [innerHTML]="data.message">
					</mat-dialog-content>
				</div>
			</div>
		</div>
		<div class="kt-portlet__foot kt-portlet__no-border kt-portlet__foot--fit text-right">
            <div class="kt-form__actions kt-form__actions--sm">
                <button  *ngIf="showCloseButton" mat-button mat-raised-button [mat-dialog-close]="true" color="primary" (click)="closeAlert(true)">
					Okay
				</button>
            </div>
        </div>
    </div>
</div>


